import { render, staticRenderFns } from "./AssessmentPrint.vue?vue&type=template&id=820da7e8"
import script from "./AssessmentPrint.vue?vue&type=script&lang=js"
export * from "./AssessmentPrint.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPrintPage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports